import React, { useEffect, useState } from "react";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";

const Profile = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [profile, setProfile] = useState({});

  useEffect(() => {
    GetProfile.get()
      .then((response) => {
        setProfile(response || {});
        console.log("🚀 Profile Data:", response);
      })
      .catch((error) => {
        console.error("Error fetching profile:", error);
        toast.error(t("login.serverError"));
      });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,     
    });
  }, []);
  

  return (
    <>
      <style>
        {`
        .profile-banner {
          background-color: var(--bs-primary-light);
          position: relative;
          height: 200px;
          overflow: hidden;
        }
        .profile-banner-pattern {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.1;
          background-image: repeating-linear-gradient(45deg, var(--bs-primary) 0, var(--bs-primary) 10px, transparent 0, transparent 50px);
        }
        .profile-image {
          width: 150px;
          height: 150px;
          border-radius: 50%;
          object-fit: cover;
          border: 5px solid white;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-top: -75px;
          position: relative;
          z-index: 10;
        }
        .profile-card {
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
        }
        .profile-card .card-body {
          padding: 2rem;
        }
        .profile-info-section {
          margin-bottom: 2rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid #f0f0f0;
        }
        .profile-info-section:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .profile-section-title {
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
          position: relative;
          padding-right: 15px;
        }
        .profile-section-title::before {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 5px;
          height: 25px;
          background-color: var(--bs-primary);
          border-radius: 5px;
        }
        .profile-stats {
          display: flex;
          justify-content: space-around;
          margin: 2rem 0;
        }
        .profile-stat {
          text-align: center;
        }
        .profile-stat .stat-value {
          font-size: 1.75rem;
          font-weight: 700;
          color: var(--bs-primary);
        }
        .profile-stat .stat-label {
          font-size: 0.9rem;
          color: #6c757d;
        }
        .profile-social-links {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .profile-social-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #f8f9fa;
          color: #6c757d;
          transition: all 0.3s;
        }
        .profile-social-link:hover {
          background-color: var(--bs-primary);
          color: white;
        }
        .specialty-badge {
          display: inline-block;
          background-color: var(--bs-primary-light);
          color: var(--bs-primary);
          border-radius: 20px;
          padding: 0.35rem 0.75rem;
          margin: 0.25rem;
          font-size: 0.875rem;
        }
        body {
          min-height: 100vh;
        }
        `}
      </style>

      <section className="profile-banner " data-aos="fade-down">
        <div className="profile-banner-pattern"></div>
      </section>

      <section className="py-5" data-aos="fade-up">
        <div className="container">
          <div className="row justify-content-center" data-aos="zoom-in">
            <div className="col-lg-10">
              <div className="text-center mb-4" data-aos="fade-up" data-aos-delay="100">
                <img
                  src={profile?.profileImage || "/assets-v2/default-avatar.png"}
                  alt="Profile"
                  className="profile-image"
                  id="profileImage"
                />
                <h1 className="mt-3 mb-2" id="profileName">
                  {isArabic ? profile?.arabicFullName : profile?.englishFullName}

                </h1>
                <p className="text-muted" id="profileJobTitle">
                  <p className="text-muted" id="profileJobTitle">
                    {isArabic
                      ? profile?.arabicJobTitle || t("not_available")
                      : profile?.englishJobTitle || t("not_available")}
                  </p>
                </p>
                <p className="mb-4" id="profileLocation">
                  <span>{isArabic ? profile?.city?.arabicName : profile?.city?.englishName || t("not_available")}</span>

                  {/* {profile?.nationality?.arabicName || t("not_available")} */}
                </p>

                <div className="d-flex flex-column flex-sm-row justify-content-center gap-2">
                  <a href="/profile-edit" className="btn btn-primary-custom">
                    {t("edit_profile")}
                  </a>
                  {profile?.hasContent && (
                    <a
                      href="/website/speaker-content.html"
                      className="btn btn-outline-primary-custom"
                      id="manageContentBtn"
                    >
                      {t("manage_content")}
                    </a>
                  )}
                </div>
              </div>

              <div className="profile-stats" data-aos="fade-up" data-aos-delay="300">
                <div className="profile-stat">
                  <div className="stat-value">
                    {profile?.speakerBookCount || 0}
                  </div>
                  <div className="stat-label">{t("my_bookings")}</div>
                </div>
                <div className="profile-stat">
                  <div className="stat-value">{profile?.favorites || 0}</div>
                  <div className="stat-label">{t("my_favorites")}</div>
                </div>
                <div className="profile-stat">
                  <div className="stat-value">{profile?.views || 0}</div>
                  <div className="stat-label">المشاهدات</div>
                </div>
              </div>

              <div className="card profile-card mb-5" data-aos="fade-up" data-aos-delay="400">
                <div className="card-body">
                  <div className="profile-info-section">
                    <h2 className="profile-section-title">{t("aboutMe")}</h2>
                    <p id="profileBio" className="mb-4">
                      {(isArabic
                        ? profile?.arabicShortBiography
                        : profile?.englishShortBiography) ||
                        t("no_bio_available")}
                    </p>

                    <div className="row mt-4">
                      <div className="col-lg-6">
                        <h5 className="mb-3">{t("domain")}</h5>
                        <p id="profileDomain" className="mb-4">
                          {isArabic ? profile?.industry?.arabicName : profile?.industry?.englishName || t("not_available")}

                        </p>
                      </div>
                      <div className="col-lg-6">
                        <h5 className="mb-3">{t("specialities")}</h5>
                        <div id="profileSpecialties">
                          {profile?.specialities?.length > 0 ? (
                            profile.specialities.map((s, idx) => (
                              <span key={idx} className="specialty-badge">
                                {s.name}
                              </span>
                            ))
                          ) : (
                            <span>{t("no_specialties")}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="profile-info-section" data-aos="fade-up" data-aos-delay="700">
                    <h2 className="profile-section-title">
                      {t("personal_information")}
                    </h2>
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li className="mb-3">
                            <strong className="me-2">{t("email")}</strong>
                            <span dir="ltr">{profile?.email}</span>
                          </li>
                          <li className="mb-3">
                            <strong className="me-2">
                              {t("mobile_number")}
                            </strong>

                            <span dir="ltr">
                              {profile?.mobile || t("not_available")}
                            </span>
                          </li>
                          <li className="mb-3">
                            <strong className="me-2">{t("gender")}</strong>
                            <span>
                              {t(`genders.${profile?.gender}`) ||
                                t("not_available")}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li className="mb-3">
                            <strong className="me-2">{t("nationality")}</strong>
                            <span>
                              {profile?.nationality?.name || t("not_available")}
                            </span>{" "}
                          </li>
                          <li className="mb-3">
                            <strong className="me-2">{t("country")}</strong>
                            <span>
                                {isArabic ? profile?.nationality?.arabicName : profile?.nationality?.englishName || t("not_available")}

                            </span>
                          </li>
                          <li className="mb-3">
                            <strong className="me-2">{t("city")}</strong>
                            <span>
                              {isArabic ? profile?.city?.arabicName : profile?.city?.englishName || t("not_available")}

                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="profile-info-section">
                    <h2 className="profile-section-title">
                      {t("job_information")}
                    </h2>
                    <div className="row">
                      <div className="col-lg-6">
                        <p>
                          <strong className="me-2">
                            {t("organization_name_ar")}
                          </strong>

                          <span>
                            {profile?.arabicJobTitle || t("not_available")}
                          </span>
                          {profile?.organizationLink && (
                            <a
                              href={profile?.organizationLink}
                              target="_blank"
                              rel="noreferrer"
                              dir="ltr"
                            >
                              {profile?.organizationLink}
                            </a>
                          )}
                        </p>
                        <p>
                          <strong className="me-2">{t("job_title_ar")}</strong>
                          <span>
                            {profile?.arabicJobTitle || t("not_available")}
                          </span>
                        </p>
                      </div>
                      <div className="col-lg-6">
                        {profile?.organizationLink && (
                          <p>
                            <strong className="me-2">
                              {t("organization_url")}
                            </strong>
                            <a
                              href={profile?.organizationLink}
                              target="_blank"
                              rel="noreferrer"
                              dir="ltr"
                            >
                              {profile?.organizationLink}
                            </a>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {profile?.linkedInLink ||
                  profile?.xLink ||
                  profile?.facebookLink ||
                  profile?.youtubeLink ||
                  profile?.scholarLink ||
                  profile?.githubLink ||
                  profile?.websiteLink ? (
                    <div className="social-share-wrapper">
                      <ul
                        className="social-icon-list d-flex align-items-center justify-content-center flex-row gap-3"
                        style={{ listStyle: "none", padding: 0 }}
                      >
                        {profile?.xLink && (
                          <li>
                            <a
                              href={profile.xLink}
                              target="_blank"
                              className="social-link"
                            >
                              <img
                                src="/assets-v2/images/icons/x.svg"
                                alt="X"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  objectFit: "contain",
                                  filter:
                                    "invert(34%) sepia(70%) saturate(320%) hue-rotate(170deg)",
                                  transition: "filter 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.filter = "invert(100%)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.filter =
                                    "invert(34%) sepia(70%) saturate(320%) hue-rotate(170deg)";
                                }}
                              />
                            </a>
                          </li>
                        )}
                        {profile?.scholarLink && (
                          <li>
                            <a
                              href={profile.scholarLink}
                              target="_blank"
                              className="social-link"
                            >
                              <img
                                src="/assets-v2/images/icons/googlescholar.svg"
                                alt="Scholar"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  objectFit: "contain",
                                  filter:
                                    "invert(34%) sepia(70%) saturate(320%) hue-rotate(170deg)",
                                  transition: "filter 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.filter = "invert(100%)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.filter =
                                    "invert(34%) sepia(70%) saturate(320%) hue-rotate(170deg)";
                                }}
                              />
                            </a>
                          </li>
                        )}
                        <ul className="d-flex list-unstyled gap-3">
                          {profile?.linkedInLink && (
                            <li>
                              <a
                                href={profile.linkedInLink}
                                target="_blank"
                                className="social-link"
                              >
                                <i className="fab fa-linkedin fa-lg social-icon"></i>
                              </a>
                            </li>
                          )}

                          {profile?.facebookLink && (
                            <li>
                              <a
                                href={profile.facebookLink}
                                target="_blank"
                                className="social-link"
                              >
                                <i className="fab fa-facebook fa-lg social-icon"></i>
                              </a>
                            </li>
                          )}

                          {profile?.youtubeLink && (
                            <li>
                              <a
                                href={profile.youtubeLink}
                                target="_blank"
                                className="social-link"
                              >
                                <i className="fab fa-youtube fa-lg social-icon"></i>
                              </a>
                            </li>
                          )}

                          {profile?.githubLink && (
                            <li>
                              <a
                                href={profile.githubLink}
                                target="_blank"
                                className="social-link"
                              >
                                <i className="fab fa-github fa-lg social-icon"></i>
                              </a>
                            </li>
                          )}

                          {profile?.websiteLink && (
                            <li>
                              <a
                                href={profile.websiteLink}
                                target="_blank"
                                className="social-link"
                              >
                                <i className="fas fa-globe fa-lg social-icon"></i>
                              </a>
                            </li>
                          )}
                        </ul>
                      </ul>
                    </div>
                  ) : (
                    <p>{t("no_social_links")}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Profile;
